import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { useSelector } from "react-redux";
import { API } from "../../config";

// Query function to fetch dashboard data
const fetchDashboardData = async ({ userInfo, year }) => {
  if (!userInfo?._id) {
    return null; // Or throw an error if preferred
  }

  const currentYear = new Date().getFullYear();
  const finalYear = year || currentYear;

  const url = `${API}/dashboard?year=${finalYear}`;


  const { data } = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${userInfo.token}`,
    },
  });

  return data;
};

// Hook to use in components
export const useDashboardData = (year = null) => {
  const { userInfo } = useSelector((state) => state.userLogin);

  return useQuery({
    queryKey: ["dashboardData", userInfo, year],
    queryFn: () => fetchDashboardData({ userInfo, year }),
    enabled: !!userInfo?._id,
    staleTime: 5 * 60 * 1000, // 5 mins
    retry: 1,
    onError: (error) => {
      if (
        error?.response?.data?.message === "Not authorized, token failed"
      ) {
        // Optionally, dispatch logout if needed
        // dispatch(logout()); <-- Avoid dispatching in hooks unless using a wrapper
        console.error("Token expired or invalid.");
      }
    },
  });
};

const fetchMonthlyRevenue = async ({ userInfo, year }) => {
  if (!userInfo?._id) return [];

  const currentYear = new Date().getFullYear();
  const finalYear = year || currentYear;

  const { data } = await axios.get(`${API}/revenue?year=${finalYear}`, {
    headers: {
      Authorization: `Bearer ${userInfo.token}`,
    },
  });

  return data;
};

// Hook
export const useMonthlyRevenue = (year = null) => {
  const { userInfo } = useSelector((state) => state.userLogin);

  return useQuery({
    queryKey: ["monthlyRevenue", userInfo, year ?? new Date().getFullYear()],
    queryFn: () => fetchMonthlyRevenue({ userInfo, year }),
    enabled: !!userInfo?._id,
    staleTime: 5 * 60 * 1000, // optional
    retry: 1,
    onError: (error) => {
      console.error("Revenue fetch error:", error);
    },
  });
};